import { AppState } from "../../../redux-configuration/AppState";

export const changeServicesOrderLoadingSelector = (appState: AppState): boolean => appState.municipality.changeOrder.loading
export const changeServicesOrderErrorSelector = (appState: AppState): string | undefined => appState.municipality.changeOrder.error
